import BaseFormPresenter from "../../../components/common/BaseFormPresenter";

class CollectionFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
  async getObject() {
    const collection = this.view.getCollectionName();
    console.log("collection", collection);
    console.log("first");
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      // const params = { include: ["all"] };
      const params = {
        include: [
          // "all",
          "committeeRelation",
          "committeeRelation.Designation",
          "committeeRelation.employee",
          "employee",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        console.log("objecrt", this.object);
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      if (
        Array.isArray(this.change.committeeRelation) &&
        this.change.committeeRelation.length > 0
      ) {
        this.change.committeeRelation = this.change.committeeRelation.map(
          (relation) => {
            const result = { ...relation };

            // Remove or replace employee
            if (relation.employee?.id) {
              result.employee = { id: relation.employee.id };
            } else {
              delete result.employee;
            }

            // Remove or replace Designation
            if (relation.Designation?.id) {
              result.Designation = { id: relation.Designation.id };
            } else {
              delete result.Designation;
            }

            return result;
          }
        );
      }
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Successfully saved.");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default CollectionFormPresenter;
